import React, { ReactNode } from 'react';

interface OutlineButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
}

const OutlineButton: React.FC<OutlineButtonProps> = ({ onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className={`tw-w-max tw-px-[16px] tw-py-[7px] tw-border-[1px] tw-border-[#091CAA] tw-text-[#091CAA] hover:tw-bg-[#091CAA] hover:tw-text-white tw-rounded-[4px] tw-transition tw-duration-300 tw-ease-in-out focus:tw-outline-none focus:tw-ring-none focus:tw-border-blue-300`}>
      {children}
    </button>

  );
};

export default OutlineButton;
